// list of all modules within the application that are required BEFORE the dom is ready
"use strict";

define('app/modules',[
    'Adobe/dataLayer',
    'Adobe/eventListeners',
    'app-Search/main',
    'app-Accordions/main',
    'app-SearchResults/main',
    'app-MultipleItineraries/main',
    'app-FindByProductCode/main',
    'app-AddressLookup/main',
    'app-deckplans/main',
    'app-DataTagPopUp/main',
    'app-InlineValidation/main',
    'app-formElements/main',
    'app-UKTSDetails/main',
    'app-TravelPortal/login/main',
    'app-TravelPortal/logout/main',
    'app-UKTSBookingSummary/main',
    'app-PageToggleTP/main',
    'app-Slider/main',
    'app-ShorexSummary/main',
    'app-PopUpTP/main',
    'app-UpdatePassengerTP/main',
    'app-FeaturePopUp/main',
    'app-PopUpTP/main',
    'app-formElementsTP/main',
    'app-Discounts/main',
    'app-CarouselWidget/main',
    'app-CarouselJumbotron/main',
    'app-ProductInfoBox/main',
    'app-Header/main',
    'app-ImageGalleryPod/main',
    'app-ConciergeTP/main',
    'app-ProductFloatingBoxRight/main',
    'app-PrettyPhoto/main',
    'app-Agents/main',
    'app-Recaptcha/main',
    'app-Blog/main',
    'app-ContactUs/main',
    'app-blazy/main',
    'app-Loader/main',
    'app-MakePayment/main',
    'app-Gdpr/main',
    'app-Forms/main',
    'app-CruiseProduct/main',
    'app-CarouselComponent/main',
    'app-ModalComponent/main',
    'app-TableCruise/main',
    'app-CarouselGalleryComponent/main',
    'app-CarouselLogoComponent/main',
    'app-Brochures/main',
    'app-emailOnly/main',
    'app-Cabins/main',
    'app-CruiseExcursions/main',
    'app-FAQNew/main',
    'BookingEngine/app-formElementsBE/main',
    'BookingEngine/app-BookingEngine/main',
    'BookingEngine/app-Passdetails/main',
    'BookingEngine/app-OceanCruises/main',
    'BookingEngine/app-OtherCruises/main',
    'BookingEngine/app-Departures/main',
    'BookingEngine/app-Reviewpay/main',
    'BookingEngine/app-BEBasket/main',
    'BookingEngine/app-Confirmation/main',
    'BookingEngine/app-general/main'
], function () {
    var apps = [];

    for (var i = 0; i < arguments.length; i++) {
        apps.push(arguments[i]);
    }

    return apps;
});
